module.exports = {
    RECEIVE_MAT_EVENTS_EXPLOITATION: 'RECEIVE_MAT_EVENTS_EXPLOITATION',
    RECEIVE_MAT_EVENTS_TYPE: 'RECEIVE_MAT_EVENTS_TYPE',
}
